import api from "@/lib/api";

function sessionId() {
  let sid = localStorage.getItem("oa_session_id");
  if (!sid) {
    sid = "sess_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("oa_session_id", sid);
  }
  return sid;
}

export function getSessionId() {
  return sessionId();
}

function utmParams() {
  const p = new URLSearchParams(window.location.search);
  const out = {};
  ["source", "medium", "campaign", "content", "term"].forEach((k) => {
    const v = p.get(`utm_${k}`);
    if (v) out[`utm_${k}`] = v;
  });
  // persist first-touch attribution
  const stored = JSON.parse(localStorage.getItem("oa_utm") || "null");
  if (Object.keys(out).length) {
    localStorage.setItem("oa_utm", JSON.stringify(out));
    return out;
  }
  return stored || {};
}

function contentRef() {
  const p = new URLSearchParams(window.location.search);
  const ref = p.get("ref");
  if (ref) localStorage.setItem("oa_content_ref", ref);  // first-touch persists
  return localStorage.getItem("oa_content_ref") || null;
}

export function referralCode() {
  const p = new URLSearchParams(window.location.search);
  const rc = p.get("rc");
  if (rc) localStorage.setItem("oa_referral_code", rc);  // first-touch persists
  return localStorage.getItem("oa_referral_code") || null;
}

export function track(event, extra = {}) {
  try {
    const device = window.innerWidth < 768 ? "mobile" : window.innerWidth < 1024 ? "tablet" : "desktop";
    const ref = contentRef();
    const rc = referralCode();
    const payload = {
      event,
      session_id: sessionId(),
      device,
      referrer: document.referrer || null,
      ...(ref ? { content_ref: ref } : {}),
      ...(rc ? { referral_code: rc } : {}),
      ...utmParams(),
      ...extra,
    };
    api.post("/events", payload).catch(() => {});
  } catch {
    /* fire-and-forget */
  }
}
